import React, { useState } from 'react';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { uploadImage, resolveImg } from '../lib/api';
import { Upload, Loader2 } from 'lucide-react';
import { useToast } from '../hooks/use-toast';

// Lets admin either paste an image URL or upload a file (stored via object storage).
export default function ImageField({ value, onChange, label = 'Image' }) {
  const [busy, setBusy] = useState(false);
  const { toast } = useToast();

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const res = await uploadImage(file);
      onChange(res.url);
      toast({ title: 'Image uploaded' });
    } catch (err) {
      toast({ title: 'Upload failed', description: err?.response?.data?.detail || 'Try again', variant: 'destructive' });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-2">
      <div className="text-xs uppercase tracking-widest text-white/50">{label}</div>
      <div className="flex gap-2">
        <Input
          data-testid="image-url-input"
          placeholder="Paste image URL or upload →"
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          className="h-11 bg-black/50 border-white/10"
        />
        <label className="shrink-0">
          <input type="file" accept="image/*" className="hidden" onChange={handleFile} data-testid="image-upload-input" />
          <Button type="button" asChild variant="outline" className="h-11 border-white/15 bg-neutral-900 cursor-pointer">
            <span>{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}</span>
          </Button>
        </label>
      </div>
      {value && (
        <img src={resolveImg(value)} alt="preview" className="w-full h-32 object-cover rounded-lg border border-white/10" />
      )}
    </div>
  );
}
